import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CartLine } from '@next/core-lib/cart';
import { Store } from '@ngrx/store';
import { openRemarksDialog } from 'src/app/cart/store/actions';

@Component({
  templateUrl: './column-remarks.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatIcon],
})
export class ColumnRemarksComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<unknown>;
  public cartId: number;
  public initCallback: () => void;

  constructor(private readonly store: Store) {}

  ngAfterViewInit() {
    this.initCallback();
  }

  public openRemarksDialog(cartLine: CartLine) {
    this.store.dispatch(openRemarksDialog({ cartId: this.cartId, cartLine }));
  }
}
